import { sdk } from 'src/utilities/sdk';
import { camelizeResponseData } from 'src/utilities/http-data-casing';
import {
  BalancePaymentMethodsCardsApiResponse,
  BalancePaymentMethodsCardsRawResponse,
} from 'src/types/Balance';

export const getBalancePaymentMethodsCardsEndpoint = (
  externalBalanceBuyerId: string
): string =>
  `/b2gexternalgateway/balance/buyers/${externalBalanceBuyerId}/payment-methods/cards`;

export async function fetchBalancePaymentMethodsCards(
  externalBalanceBuyerId: string
): Promise<BalancePaymentMethodsCardsApiResponse> {
  const response: BalancePaymentMethodsCardsRawResponse = await sdk.http.get(
    getBalancePaymentMethodsCardsEndpoint(externalBalanceBuyerId)
  );
  return camelizeResponseData(response);
}
